<vb-app-footer
    [logoSrc]="logoSrc"
    [browseLinks]="browseLinks"
    [infoLinks]="infoLinks"
    [mapSrc]="mapSrc"
    [hours]="hours"
    (linkSelect)="onLinkSelect($event)">
</vb-app-footer>
